'use client'

import { useState } from 'react'
import { useRouter, useSearchParams, usePathname } from 'next/navigation'
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid' // Import Hero Icons

const SearchBar = () => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const [searchTerm, setSearchTerm] = useState(
    () => searchParams.get('search') || ''
  )

  const handleSubmit = () => {
    const trimmedSearchTerm = searchTerm.trim()

    if (trimmedSearchTerm !== '') {
      const params = new URLSearchParams({
        query: trimmedSearchTerm,
        filter: 'IN_STOCK',
      })
      router.push(`/search?${params.toString()}`)
      return
    }

    router.push(pathname)
  }

  return (
    <div className="border rounded p-4 my-4">
      <div className="flex flex-col md:flex-row items-start md:items-center">
        <div className="md:w-2/3">
          <h2 className="text-3xl font-semibold mb-1">
            Looking for a particular prop?
          </h2>
          <p className="text-vi-gray font-medium">
            Search over 1,000 props and utilities at Vanishing Inc.
          </p>
        </div>
        <div className="md:w-1/3 mt-4 md:mt-0">
          <div className="relative flex items-center">
            <input
              type="text"
              id="searchterm"
              value={searchTerm}
              onChange={e => setSearchTerm(e.target.value)}
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  handleSubmit()
                }
              }}
              className="w-full border border-gray-300 rounded-full py-2.5 px-5 text-lg focus:outline-none focus:ring-2 focus:ring-vi-red focus:border-vi-red transition-all placeholder-gray-500"
              placeholder="Search here..."
            />
            <button
              type="button"
              id="searchbtn"
              onClick={handleSubmit}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 bg-vi-red text-white rounded-full p-2 transition-transform duration-300 hover:scale-105"
            >
              <MagnifyingGlassIcon className="h-6 w-6 text-white" />
            </button>
          </div>
          <p className="text-gray-500 mt-2 text-end">
            Type your search term and press enter
          </p>
        </div>
      </div>
    </div>
  )
}

export default SearchBar
